import readdirGlob from './index';
export default readdirGlob;
